export const GET_ALL_STATIC_PAGES = "GET_ALL_STATIC_PAGES"
export const GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS =
  "GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS"
export const CREATE_STATIC_PAGE = "CREATE_STATIC_PAGE"
export const UPDATE_STATIC_PAGE = "UPDATE_STATIC_PAGE"
export const DELETE_STATIC_PAGE = "DELETE_STATIC_PAGE"
